import "./Footer.scss";

function Footer() {
  return (
    <div class="footer_container">
      <div class="footer_links">
        <a href="/">Home</a>
        <a href="/unsubscribe">Unsubscribe</a>
        <a href="https://linktr.ee/">LinkTree</a>
        <a href="mailto:weeklytree.notifs@gmail.com">weeklytree.notifs@gmail.com</a>
      </div>
    </div>
  )
}

export default Footer;